import React, { useState } from 'react';
import './SideMenu.css';
import {
  Checkbox,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import CloseIcon from '@mui/icons-material/Close';

import Grid2 from '@mui/material/Grid2/Grid2';
import { Category, Option } from '../../interfaces/SideMenu.interface';

interface SideMenuProps {
  categories: Category[];
  selectedOptions: Option[];
  setSelectedOptions: React.Dispatch<React.SetStateAction<Option[]>>;
}

const SideMenu: React.FC<SideMenuProps> = ({ categories, selectedOptions, setSelectedOptions }) => {
  const [expandedSections, setExpandedSections] = useState<Record<string, boolean>>({});
  //const [selectedOptions, setSelectedOptions] = useState<Option[]>([]);

  const toggleSection = (sectionId: string) => {
    setExpandedSections((prevState) => ({
      ...prevState,
      [sectionId]: !prevState[sectionId],
    }));
  };

  const handleOptionToggle = (option: Option) => {
    const isSelected = selectedOptions.some((item) => item.id === option.id);
    if (isSelected) {
      setSelectedOptions((prevOptions) =>
        prevOptions.filter((item) => item.id !== option.id)
      );
    } else {
      setSelectedOptions((prevOptions) => [...prevOptions, option]);
    }
  };

  const handleRemoveSelectedOption = (option: Option) => {
    setSelectedOptions((prevOptions) =>
      prevOptions.filter((item) => item.id !== option.id)
    );
  };

  // Agrupar opciones seleccionadas por categoría
  const selectedOptionsByCategory = categories.reduce<Record<string, Option[]>>((acc, category) => {
    const selectedInCategory = selectedOptions.filter((option) =>
      category.options.some((catOption) => catOption.id === option.id)
    );
    if (selectedInCategory.length > 0) {
      acc[category.id] = selectedInCategory;
    }
    return acc;
  }, {});

  return (
    <Grid2 className="side-menu-container">
      <Grid2 className="side-menu">
        {categories.map((category) => (
          <Grid2 key={category.id} className="side-menu-section">
            <Grid2 className="side-menu-header" onClick={() => toggleSection(category.id)}>
              {category.image && category.image !== '' && (
                <span className="side-menu-icon">
                  <img className="side-menu-icon" src={category.image} alt={category.title} />
                </span>
              )}
              <Typography variant="body1" className="side-menu-title">
                {category.title}
              </Typography>
              <IconButton size="small">
                {expandedSections[category.id] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            </Grid2>
            <Collapse in={expandedSections[category.id]} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {category.options.map((option) => (
                  <ListItem key={option.id} className="side-menu-option">
                    <ListItemIcon>
                      <Checkbox className='side-menu-option-check'
                        checked={selectedOptions.some((item) => item.id === option.id)}
                        onChange={() => handleOptionToggle(option)}
                      />
                    </ListItemIcon>
                    <ListItemText className="side-menu-option-text" primary={option.nombre} />
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </Grid2>
        ))}
      </Grid2>

      {/* Contenedor de opciones seleccionadas por categoría */}
      <Box className="selected-options-container">
        <Typography variant="body2">Filtros aplicados</Typography>
        {Object.entries(selectedOptionsByCategory).map(([categoryId, options]) => {
          const category = categories.find((cat) => cat.id === categoryId);
          return (
            <Box key={categoryId} className="selected-category-container">
              <Box display="flex" alignItems="center">
                {category?.image && (
                  <span className="side-menu-icon">
                    <img className="side-menu-icon" src={category.image} alt={category.title} />
                  </span>
                )}
                <Typography variant="body1" className="side-menu-title">
                  {category?.title}
                </Typography>
              </Box>
              <Box className="selected-options-wrapper">
                {options.map((option) => (
                  <Box key={option.id} className="selected-option">
                    <Typography variant="body2">{option.nombre}</Typography>
                    <IconButton
                      size="small"
                      onClick={() => handleRemoveSelectedOption(option)}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>
                ))}
              </Box>
            </Box>
          );
        })}
      </Box>
    </Grid2>
  );
};

export default SideMenu;
